<button mat-mini-fab [ngClass]="{'beta-customer': isBetaCustomer}" matTooltip="Your Account"
        class="user-profile-button mat-elevation-z0" [matMenuTriggerFor]="userProfile">{{userInitials}}</button>

<mat-menu #userProfile class="user-profile" [ngClass]="{'beta-customer': isBetaCustomer}">
  <mat-card class="user-profile-card">
    <mat-card-content class="mat-body-2" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="sidebar-user__avatar">{{userInitials}}</div>
        <div fxFlex>
          <div class="font-weight-bold">{{userName}}</div>
          <div class="text-muted">{{userEmail}}</div>
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="10px">
        <div class="text-muted">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" *ngIf="!hasMultipleCompanies">
            <mat-icon>domain</mat-icon>
            <span>{{customerProfileName}}</span>
          </div>
          <button mat-stroked-button matTooltip="Switch Company" *ngIf="hasMultipleCompanies" type="button" style="width: 240px" (click)="openSwitchCompanyDialog()">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <mat-icon>domain</mat-icon>
              <span style="text-overflow: ellipsis; overflow: hidden;">{{customerProfileName}}</span>
            </div>
          </button>
        </div>
        <a mat-flat-button color="primary" routerLink="{{profileUrl}}" *ngIf="hasEditAccess">My Account</a>
      </div>
    </mat-card-content>
    <mat-card-footer fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <span>v{{version}}</span>
      <button type="button" mat-flat-button color="warn" class="logout-button" (click)="logoutConfirm()">Sign Out</button>
    </mat-card-footer>
  </mat-card>
</mat-menu>
